export default __webpack_public_path__ + "static/media/07_Livingroom-Interior-Architecture-EschweilerPhotography07.3ffa1f47.jpg";